import React, { useMemo, useRef } from "react";
import { Card, Stack, Typography } from "@curves/ui-base";
import {
	inBodyInterviewMeasureItems,
	inBodyInterviewNotesItems
} from "@icoach/inbody/interview/InBodyInterviewMeasureNormalBox";
import InBodyInterviewDialogBox from "@icoach/inbody/dialog/InBodyInterviewDialogBox";
import { InBodyProvider } from "@icoach/inbody/components/InBodyContext";
import useGetMeasureRecordsState from "@util/hook/useGetMeasureRecordsState";
import { isEmpty } from "@util/utils";
import { MEASURE_REFERENCE_TYPE } from "@icoach/constants";
import { MeasureRecordTable } from "@icoach/inbody/components";
import { useMemberDetailContext } from "@icoach/memberDetail/MemberDetailContext";

const MemberDetailInbodyContent = ({ memberID }) => {
	const { getMemberProfile } = useMemberDetailContext();
	const { measureData, getInterviewMeasureApi } = useGetMeasureRecordsState({
		referenceType: MEASURE_REFERENCE_TYPE.MEMBER,
		referenceID: memberID,
	});

	const dialogRef = useRef(null);

	const inbodyMeasureItems = useMemo(
		() => {
			return [...inBodyInterviewMeasureItems.slice(0, inBodyInterviewMeasureItems.length - 1), ...inBodyInterviewNotesItems.slice(1)];
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<InBodyProvider
			value={{
				dialogRef: dialogRef,
				peopleID: memberID,
				refresh: () => {
					getMemberProfile();
					getInterviewMeasureApi();
				}
			}}
		>
			<React.Fragment>
				<Card>
					<Card.CardContent className={"p-3"}>
						{!isEmpty(measureData) ? (
							<MeasureRecordTable sourceData={measureData} measureItems={inbodyMeasureItems} />
						) : (
							<Stack justifyContent={"center"} alignItems={"center"}>
								<Typography variant="h6" className={"font-color-4"}>
									無相關資料
								</Typography>
							</Stack>
						)}
					</Card.CardContent>
				</Card>
				<InBodyInterviewDialogBox ref={dialogRef} />
			</React.Fragment>
		</InBodyProvider>
	)
		;
};

export default MemberDetailInbodyContent;
